<template>
    <div class="vx-col  w-full mb-6" :class="wrapclass" >
        <template v-if="checkProperty(value, 'beneficiaryInfo', 'benfAssets') && checkProperty(value['beneficiaryInfo'], 'benfAssets', 'length')>0">
            <div class="form-container form-container-v2">
                <div class="vx-row">
                    <div class="vx-col w-full mb-5 mt-0">
                        <h3 class="small-header mt-0">Assests</h3>
                    </div>
                    <div class="vx-col w-full prior-stay-list periods-nowrap">
                        <div class="vx-row delete-row" v-for="(assest, index) in value['beneficiaryInfo']['benfAssets']" :key="index">
                            <div class="vx-col w-full">
                            <vx-input-group class="form-input-group FML">
                                <immiInput :notRequired="notRequired" :display="false" :fieldsArray="fieldsArray" :tplkey="'firstName'" :cid="'atfirstName'+index" :formscope="formscope" v-model=assest.firstName :required="true" :tplsection="'beneficiaryInfo.benfAssets'" :fieldName="'firstName'+index" label="First Name" placeHolder="First Name" />
                                <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :tplkey="'middleName'" :cid="'atmiddleName'+index" :formscope="formscope" v-model="assest.middleName" :required="true" :tplsection="'beneficiaryInfo.benfAssets'" :fieldName="'middleName'+index" label="Middle Name" placeHolder="Middle Name" />
                                <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray" :tplkey="'lastName'" :cid="'atlastName'+index" :formscope="formscope" v-model="assest.lastName" :required="true" :fieldName="'lastName'+index" :tplsection="'beneficiaryInfo.benfAssets'" label="Last Name" placeHolder="Last Name" />
                            </vx-input-group>
                            </div>
                            <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :formscope="formscope" wrapclass="md:w-1/2" :cid="'typeOfAsset'+index"  :tplkey="'typeOfAsset'"  v-model="assest.typeOfAsset" :tplsection="'beneficiaryInfo.benfAssets'" :required="true" :fieldName="'typeOfAsset'+index" label="Type of Asset" placeHolder="Type of Asset" />

                            <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :formscope="formscope" wrapclass="md:w-1/2" :cid="'amount'+index"  :tplkey="'amount'"  v-model="assest.amount" :tplsection="'beneficiaryInfo.benfAssets'" :required="true" :fieldName="'amount'+index" label="Amount" placeHolder="Amount" />

                            <div class="delete" v-if="checkProperty(value['beneficiaryInfo'], 'benfAssets', 'length') > 1" @click="removeAssets(index)">
                                <a>
                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                <a @click="addAssets" class="add-more ml-0 mt-0" style="display:inline-block" type="filled">
                    <span>+</span> More
                </a>
            </div>
        </template>
        <template v-if="checkProperty(value, 'beneficiaryInfo', 'benfIncome') && checkProperty(value['beneficiaryInfo'], 'benfIncome', 'length')>0">
            <div class="form-container form-container-v2">
                <div class="vx-row">
                    <div class="vx-col w-full mb-5 mt-0">
                        <h3 class="small-header mt-0">Income</h3>
                    </div>
                    <div class="vx-col w-full prior-stay-list periods-nowrap">
                        <div class="vx-row delete-row" v-for="(income, index) in value['beneficiaryInfo']['benfIncome']" :key="index">
                            <div class="vx-col w-full">
                            <vx-input-group class="form-input-group FML">
                                <immiInput :notRequired="notRequired" :display="false" :fieldsArray="fieldsArray" :tplkey="'firstName'" :cid="'atfirstName'+index" :formscope="formscope" v-model=income.firstName :required="true" :tplsection="'beneficiaryInfo.benfIncome'" :fieldName="'firstName'+index" label="First Name" placeHolder="First Name" />
                                <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :tplkey="'middleName'" :cid="'atmiddleName'+index" :formscope="formscope" v-model="income.middleName" :required="true" :tplsection="'beneficiaryInfo.benfIncome'" :fieldName="'middleName'+index" label="Middle Name" placeHolder="Middle Name" />
                                <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray" :tplkey="'lastName'" :cid="'atlastName'+index" :formscope="formscope" v-model="income.lastName" :required="true" :fieldName="'lastName'+index" :tplsection="'beneficiaryInfo.benfIncome'" label="Last Name" placeHolder="Last Name" />
                            </vx-input-group>
                            </div>
                            <datepickerField :display="false" :tplkey="'dateOfBirth'" :fieldsArray="questionnaireDetails" :validationRequired="true" v-model="income.dateOfBirth"  :tplsection="'beneficiaryInfo.benfIncome'"  :fieldName="'dateOfBirth'+index"  :formscope="formscope"  :dateEnableTo="featureDates" label="Date of Birth" />

                            <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :formscope="formscope" wrapclass="md:w-1/2" :cid="'relToTheBenf'+index"  :tplkey="'relToTheBenf'"  v-model="income.relToTheBenf" :tplsection="'beneficiaryInfo.benfIncome'" :required="true" :fieldName="'relToTheBenf'+index" label="Relationship to the Beneficiary" placeHolder="Relationship to the Beneficiary" />

                            <immiInput :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :formscope="formscope" wrapclass="md:w-1/2" :cid="'amount'+index"  :tplkey="'amount'"  v-model="income.amount" :tplsection="'beneficiaryInfo.benfIncome'" :required="true" :fieldName="'amount'+index" label="Amount" placeHolder="Amount" />

                            <div class="delete" v-if="checkProperty(value['beneficiaryInfo'], 'benfIncome', 'length') > 1" @click="removeIncome(index)">
                                <a>
                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                <a @click="addIncome" class="add-more ml-0 mt-0" style="display:inline-block" type="filled">
                    <span>+</span> More
                </a>
            </div>
        </template>
        <immiyesorno :notRequired="notRequired" wrapclass=" " :required="checkFieldIsRequired({'key':'illegalGamblingOrDrug','section':'beneficiaryInfo', 'fieldsArray':fieldsArray, 'required':true,'notRequired':notRequired })" :tplkey="'illegalGamblingOrDrug'"  :display="false" :fieldsArray="fieldsArray" :formscope="formscope" cid="illegalGamblingOrDrug"  v-model="value.beneficiaryInfo.illegalGamblingOrDrug" :tplsection="'beneficiaryInfo'"  :fieldName="'illegalGamblingOrDrug'"  label="Does any of the beneficiary's total income (including income from dependents and other individuals who contribute to the beneficiary's income, excluding any individuals) come from an illegal activity or source (such as proceeds from illegal gambling or illegal drug sales)?"></immiyesorno>

        <immiInput v-if="checkProperty(value, 'beneficiaryInfo', 'illegalGamblingOrDrug')" :notRequired="notRequired" :display="false"  :fieldsArray="fieldsArray"  :formscope="formscope" wrapclass="md:w-1/2" :cid="'illegalActivityOrSource'"  :tplkey="'illegalActivityOrSource'"  v-model="value.beneficiaryInfo.illegalActivityOrSource" :tplsection="'beneficiaryInfo'" :required="true" :fieldName="'illegalActivityOrSource'" label="What amount of the beneficiary's total income comes from an illegal activity or source" placeHolder="What amount of the beneficiary's total income comes from an illegal activity or source" />

       
    </div>
</template>
    <script>
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    
    import Vue from "vue";
    import moment from 'moment'
    import immiyesorno from "@/views/forms/fields/yesorno.vue";
    import _ from "lodash";
    export default {
        inject: ["parentValidator"],
    
        props: {
            notRequired:{
                type: Boolean,
                default: false,
            },
            fieldsArray: Array,
            value: Array,
            petition: Object,
            wrapclass:{
            type:String,
                default:""
            },
            formscope: {
                type: String,
                default: ''
            },
            cid: {
                type: String,
                default: "",
            },
            fieldName: {
                type: String,
                default: null,
            },
            tplsection:{
                type: String,
                default: null,
            },
            placeHolder: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
            display: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {

            };
        },
        created() {
            this.$validator = this.parentValidator;
        },
        computed: {
    
        },
        watch: {
    
        },
        mounted() {
    
        },
        methods: {
            addAssets: function () {
                let obj = {
                    firstName: '',
                    lastName: '',
                    middleName: '',
                    typeOfAsset: '',
                    amount: '' 
                }
                this.value['beneficiaryInfo']['benfAssets'].push(obj);
            },
            addIncome: function () {
                let obj = {
                    firstName: '',
                    lastName: '',
                    middleName: '',
                    dateOfBirth: null,
                    relToTheBenf: '',
                    amount: ''
                }
                this.value['beneficiaryInfo']['benfIncome'].push(obj);
            },
            removeAssets: function (index) {
                Vue.delete(this.value['beneficiaryInfo']['benfAssets'], index);
            },
            removeIncome: function (index) {
                Vue.delete(this.value['beneficiaryInfo']['benfIncome'], index);
            }
        },
    
        components: {
            datepickerField,
            selectField,
            immiInput,
            immiyesorno
        }
    };
    </script>
    